import React from "react";
import GreenTick from "../../clinetAssets/images/green_tick.png";
import ClientHeader from "../Partials/ClientHeader";
import ClientSideBar from "../Partials/ClientSideBar";
import { base_url_client } from "../../Constants/config";
import { toast } from "react-toastify";

const PaymentSuccessful = () => {

    const handleViewDetails=()=>{
      window.location.replace(base_url_client +"/listing-page");
    }

    const handleInitiateCase=()=>{
      window.location.replace(base_url_client +"/dashboard/ivc-add/addCandidate");
        
    }
  return (
    <>
       <ClientHeader/>
      <ClientSideBar activePage="dashboard"/>

      <div class="wrapper h-100 light-blue-template">
        <section class="main-content w-100 d-block">
          <div className="m-5 p-5 d-flex flex-column justify-content-center align-items-center">
            <div className="row d-flex justify-content-center align-items-center py-1 my-1">
              <img
                src={GreenTick}
                alt="green-tick"
                style={{ width: "117px", height: "117px" }}
              />
            </div>
            <div
              className="row d-flex justify-content-center align-items-center py-1 my-1"
              style={{ fontSize: "30px", fontWeight: 700 }}
            >
              Payment Successful
            </div>
            <div
              className="row d-flex justify-content-center align-items-center py-1 my-3"
              style={{ fontSize: "19px", fontWeight: 600 }}
            >
             Your Candidate profile has been successfully submitted for verification.
            </div>
            <div className="row w-100 d-flex justify-content-center align-items-center py-1 my-1">
              <div
                className="col-2 btn btn-primary px-2 m-2"
                style={{ fontSize: "14px" }}
                onClick={handleViewDetails}
              >
                View Details
              </div>
              <div
                className="col-2 btn btn-outline-secondary-nohover text-primary px-2 m-2"
                style={{ backgroundColor: "#EFF8FF", fontSize: "14px" }}
                onClick={handleInitiateCase}
              >
                Initiate a new Case
              </div>
            </div>
            <div className="row d-flex justify-content-center align-items-center py-1 my-1">
            </div>
          </div>
          <div className="d-flex align-items-baseline justify-content-center fixed-bottom pb-3 text-secondary" style={{fontSize: "14px"}}>Copyright © 2022 by AuthBridge. All Rights Reserved</div>
        </section>
      </div>
    </>
  );
};

export default PaymentSuccessful;
